import MenuContent from './menu-content';

export default MenuContent;
